// extracted by mini-css-extract-plugin
module.exports = {"products":"select-fuel_products__vEm20","vertical":"select-fuel_vertical__2h3kY"};